<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-enter-theme`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_851dbad682__clip0_1:1687)"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.901 32.904c-.05.06-.105.115-.164.165l-9.433 7.981A1.4 1.4 0 0114 39.981V34H5a1 1 0 01-1-1v-2a1 1 0 011-1h9v-5.982a1.4 1.4 0 012.304-1.068l9.433 7.981a1.4 1.4 0 01.164 1.973zM6 5a1 1 0 01.883-.993L7 4h33a2 2 0 011.995 1.85L42 6v36a2 2 0 01-1.85 1.995L40 44H25a1 1 0 01-.993-.883L24 43v-2a1 1 0 01.883-.993L25 40h13V8H10v13a1 1 0 01-1 1H7a1 1 0 01-1-1V5z"/></g><defs><clipPath id="svg_851dbad682__clip0_1:1687"><path d="M0 0h48v48H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconEnterTheme',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
